import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { color, heightAttributes, propsBlocker, getComponentOverride } from '../../../system';

var getRootDynamicStyle = function getRootDynamicStyle(_ref) {
  var isHeader = _ref.isHeader;
  var result = {};

  if (!isHeader) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            &:hover td {\n                background-color: ", ";\n            }\n        "])), result, color('primary.lightest'));
  }

  return result;
};

export var TableRowRoot = styled.tr.withConfig(propsBlocker)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &:not(:last-child) {\n        border-bottom-width: 1px;\n        border-bottom-style: solid;\n    }\n\n    border-color: ", ";\n    background-color: ", ";\n\n    ", ";\n    ", ";\n    ", ";\n"])), color('neutral.03'), color('neutral.01'), getRootDynamicStyle, getComponentOverride('TableRow'), heightAttributes);